import {
  ROLE_FINANCIAL_AUDITOR,
  ROLE_REGULATORY_REPORTING,
  ROLE_SAAS_ACCOUNTING,
} from "@constants";

export const REGULATORY_REPORTING_ROLES = [
  ROLE_REGULATORY_REPORTING,
  ROLE_FINANCIAL_AUDITOR,
];

export const INVOICING_AND_COMPLIANCE_ROLES = [
  ROLE_SAAS_ACCOUNTING,
  ...REGULATORY_REPORTING_ROLES,
];
